import React from "react"
import DropzoneComponent from "react-dropzone-component"
import { useDispatch } from "react-redux"
import {
  addFileToList,
  removeFileFromList,
  resetSelectDocument,
  updateUiData,
} from "../redux/actions"
import * as API from "../services/httpService"
import GatsbyConfig from "../../gatsby-config"
import {
  largeUploadedFile,
  errorWhenUpload,
} from "../services/sweetalertService"

const Dropzone = ({ uiData, previewsContainer }) => {
  const { folderName, tempSelectedDocument, totalFileSize, claimUploadListModel, } = uiData
  const { documentId, documentDesc } = tempSelectedDocument

  const dispatch = useDispatch()
  const apiPreFix = GatsbyConfig.siteMetadata.apiPreFix

  let preFix = process.env.NODE_ENV !== "development" ? apiPreFix : ""
  let currentFileSize = 0

  function cleanString(inputString) {
    // Remove non-alphanumeric characters and spaces
    const cleanedString = inputString.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()

    return cleanedString
  }

  var componentConfig = {
    iconFiletypes: [".jpg", ".png", ".jpeg", ".pdf"],
    showFiletypeIcon: false,
    postUrl: preFix + "/Claim/ClaimDocsUpload",
  }

  // For a full list of possible configurations,
  // please consult http://www.dropzonejs.com/#configuration
  const djsConfig = {
    params: {
      folderName: folderName,
      documentName: documentDesc,
      documentId: documentId,
    },
    accept: function(file, done) {
      if (totalFileSize > 25) {
        dispatch(updateUiData("exceededFileSizeLimit", true))

        done(
          "Has exceeded the 20MB total file size limit. Please reupload another file with smaller size."
        )
      } else {
        dispatch(updateUiData("exceededFileSizeLimit", false))

        done()
      }

      var currentFileSize = file.size / 1000000

      if (currentFileSize > 10 && currentFileSize < 25) {
        largeUploadedFile()
        dispatch(updateUiData("lockUploadDropdown", true))
      }
    },
    paramName: "file",
    dictDefaultMessage: "",
    maxFilesize: 25,
    clickable: true,
    addRemoveLinks: true,
    acceptedFiles: ".png,.jpg,.jpeg,.pdf",
    dictRemoveFile: "X",
    dictInvalidFileType: "Only accept file type: .png, .jpg, .jpeg, .pdf",
    uploadMultiple: false,
    forceFallback: false,
    parallelUploads: 1,
    autoProcessQueue: true,
    timeout: 360000,
    previewsContainer: "#" + previewsContainer,
  }

  var dropzone = null

  // For a list of all possible events (there are many), see README.md!
  const eventHandlers = {
    init: dz => {
      dropzone = dz
    },
    removedfile: file => {
      API.apiPostRequest("/Claim/ClaimDocsDelete", null, {
        params: {
          fName: file.new_name,
          folderName: file.folderName,
        },
      }).then(response => {
        if (response.data.status === "success") {
          claimUploadListModel.map(
            item => (
              //check for filename and respective compressed filesize
              cleanString(item.fileName) === cleanString(file.new_name)
                ? (currentFileSize = item.compressedFilesize)
                : "",
              cleanString(item.fileName) === cleanString(file.new_name)
                ? dispatch(removeFileFromList(file.new_name, currentFileSize))
                : ""
            )
          )
        }
      })
    },
    success: (file, response) => {
      if (response !== null && response !== "") {
        dispatch(
          addFileToList(
            response.fileName,
            response.documentId,
            response.newPath,
            file.size,
            response.folderName,
            response.compressedFilesize
          )
        )
        file.new_name = response.fileName
        file.folderName = response.folderName
        dispatch(resetSelectDocument())
      } else {
        console.log("api response:" + JSON.stringify(response))
       errorWhenUpload()
       dispatch(resetSelectDocument())
      }
      dispatch(updateUiData("lockUploadDropdown", false))
    },
    error: () => {
      dispatch(resetSelectDocument())
      dispatch(updateUiData("lockUploadDropdown", false))
    },
  }

  return (
    <DropzoneComponent
      className={
        "col-2 marginTop10px " +
        "SupportDocumentUploadButton " +
        (documentId === 0 ? "hide" : "")
      }
      config={componentConfig}
      eventHandlers={eventHandlers}
      djsConfig={djsConfig}
    />
  )
}

export default Dropzone
